(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-personal-picks"] && !Shopify.designMode) return;
  try {
    
function initTableTalesShelves(){
document.querySelectorAll('[data-tt-shelf]').forEach(shelf=>{
if(shelf.dataset.ready)return;shelf.dataset.ready='true';
shelf.querySelectorAll('[data-tt-open]').forEach(button=>{
const dialog=document.getElementById(button.dataset.ttOpen);
if(!dialog)return;
button.addEventListener('click',()=>dialog.showModal());
dialog.querySelector('[data-tt-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
dialog.addEventListener('close',()=>button.focus({preventScroll:true}));
});
});
}
initTableTalesShelves();
document.addEventListener('shopify:section:load',initTableTalesShelves);

  } catch(e) { console.error(e); }
})();
})();
